import { useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Páginas fijas con mapa de calor (deben coincidir con TRACKED_PAGES del backend). */
export const TRACKED_PAGES = ["/", "/tours", "/calendario", "/fin-de-semana", "/entre-semana",
  "/principiantes"];

/** Registra clics (posición relativa) y hasta dónde bajó la persona. Recibe el id de la ruta
 *  o una ruta fija como "/tours". */
export const useInteractionTracking = (routeId) => {
  useEffect(() => {
    if (!routeId) return undefined;
    const clicks = [];
    const startedAt = Date.now();
    let maxScroll = 0;

    const docHeight = () => Math.max(
      document.documentElement.scrollHeight, document.body.scrollHeight, 1);

    const onClick = (e) => {
      if (clicks.length >= 120) return;
      clicks.push({
        x: Math.min(Math.max(e.pageX / Math.max(window.innerWidth, 1), 0), 1),
        y: Math.min(Math.max(e.pageY / docHeight(), 0), 1),
      });
    };

    const onScroll = () => {
      const reached = (window.scrollY + window.innerHeight) / docHeight();
      maxScroll = Math.min(Math.max(reached, maxScroll), 1);
    };

    const flush = () => {
      if (!clicks.length && maxScroll <= 0) return;
      const isPage = routeId.startsWith("/");
      const body = JSON.stringify({
        clicks: [...clicks], max_scroll: maxScroll, mobile: window.innerWidth < 768,
        seconds: Math.round((Date.now() - startedAt) / 1000),
        ...(isPage ? { page: routeId } : {}),
      });
      clicks.length = 0;
      maxScroll = 0;
      const url = isPage ? `${API}/pages/interactions`
        : `${API}/routes/${routeId}/interactions`;
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      } else {
        fetch(url, { method: "POST", body, keepalive: true,
          headers: { "Content-Type": "application/json" } }).catch(() => {});
      }
    };

    onScroll();
    window.addEventListener("click", onClick, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("pagehide", flush);
    return () => {
      window.removeEventListener("click", onClick);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("pagehide", flush);
      flush();
    };
  }, [routeId]);
};
